import type { IToastConfig } from 'src/common/primitives/Toast';

export function generateEditSuccessToast(entity: string): IToastConfig {
  return {
    title: `${entity} updated successfully`,
  };
}
